import {useMemo} from 'react';
import {Tooltip} from 'react-leaflet';

import {Locale} from '../../../../provider/locale/localization';
import {LocalPackGridItemStatusEnum, LocalPackGridItemType} from '../../../../service/local-pack/local-pack-type';
import {LocalPackResultIcon} from '../local-pack-result-icon/local-pack-result-icon';

import * as styles from './local-pack-result-map-tooltip.scss';

type PropsType = {
    gridItem: LocalPackGridItemType;
};

export function LocalPackResultMapTooltip(props: PropsType): JSX.Element {
    const {gridItem} = props;

    const {searchResults, status, isAd, position} = gridItem;

    const tooltipContent = useMemo(() => {
        switch (true) {
            case status === LocalPackGridItemStatusEnum.Complete && position === null && searchResults.length === 1:
                return (
                    <div className={styles.ResultsOnMapTooltip_content}>
                        <Locale stringKey="LOCAL_PACK__MAP__STATUS__NO_COMPANIES_IN_RESULTS" />
                    </div>
                );
            case status === LocalPackGridItemStatusEnum.New:
                return (
                    <div className={styles.ResultsOnMapTooltip_content}>
                        <Locale stringKey="LOCAL_PACK__MAP__STATUS__NEW" />
                    </div>
                );
            case isAd:
            case status === LocalPackGridItemStatusEnum.Complete:
                return searchResults.length > 1 ? (
                    <div>
                        {searchResults.map((searchResult) => (
                            <div className={styles.ResultsOnMapTooltip_content} key={searchResult.id}>
                                <LocalPackResultIcon isAd={searchResult.isAd} position={searchResult.position} />
                                <span className={styles.ResultsOnMapTooltip_name}>{searchResult.name}</span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.ResultsOnMapTooltip_content}>
                        <Locale stringKey="LOCAL_PACK__MAP__RESULTS_OUTDATED" />
                    </div>
                );
            case status === LocalPackGridItemStatusEnum.Empty:
                return (
                    <div className={styles.ResultsOnMapTooltip_content}>
                        <Locale stringKey="LOCAL_PACK__MAP__STATUS__EMPTY" />
                    </div>
                );
            default:
                return (
                    <div className={styles.ResultsOnMapTooltip_content}>
                        <Locale stringKey="LOCAL_PACK__MAP__STATUS__NO_RESULTS" />
                    </div>
                );
        }
    }, [isAd, position, searchResults, status]);

    return (
        <Tooltip className={styles.ResultsOnMapTooltip} direction="auto">
            {tooltipContent}
        </Tooltip>
    );
}
